import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-pause-icon]',
  template: `
    <svg:path
      d="M7.875 0.916016C8.63439 0.916016 9.25 1.53162 9.25 2.29102V21.541C9.25 22.3004 8.63439 22.916 7.875 22.916C7.11561 22.916 6.5 22.3004 6.5 21.541V2.29102C6.5 1.53162 7.11561 0.916016 7.875 0.916016ZM16.125 0.916016C16.8844 0.916016 17.5 1.53162 17.5 2.29102V21.541C17.5 22.3004 16.8844 22.916 16.125 22.916C15.3656 22.916 14.75 22.3004 14.75 21.541V2.29102C14.75 1.53162 15.3656 0.916016 16.125 0.916016Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PauseIcon {
  readonly viewBox = input<string>('0 0 24 24');
  readonly extraClass = input<string>('');
}
